import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_QUESTIONNAIRES_SETTINGS = gql`
  query getEmployeeQuestionnaireSetting($companyId: String!, $queryOptions: QueryOptionsInput) {
    getEmployeeQuestionnaireSetting(companyId: $companyId, queryOptions: $queryOptions) {
      collection {
        _id
        settings
        name
        companyId
        createdBy
      }
      totalCount
    }
  }
`;

export const useGetEmployeeQuestionnaireSetting = (companyId?: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([
    { field: 'name', sortBy: 1 },
  ]);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_QUESTIONNAIRES_SETTINGS, {
    variables: {
      companyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    skip: !companyId,
    fetchPolicy: 'no-cache',
  });

  const getEmployeeQuestionnaireSetting = data?.getEmployeeQuestionnaireSetting || {};

  return {
    collection: getEmployeeQuestionnaireSetting?.collection || [],
    loading,
    paginationConfig: {
      total: getEmployeeQuestionnaireSetting?.totalCount || 0,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'name', sortBy }]);
      }
    },
  };
};

export const useGetAllEmployeeQuestionnaireSetting = (companyId?: string) => {
  const { data, loading } = useQuery(GET_QUESTIONNAIRES_SETTINGS, {
    variables: { companyId },
    skip: !companyId,
    fetchPolicy: 'no-cache',
  });

  const collection = data?.getEmployeeQuestionnaireSetting?.collection || [];

  return {
    collection,
    loading,
  };
};
